import {
  AccountBalance,
  Campaign,
  Chat,
  DeleteForever,
  Folder,
  Groups,
  Help,
  Language,
  QuestionMark,
  Receipt,
} from "@mui/icons-material";
import { SidebarItemsType } from "../../types/sidebar";

import {
  Map,
  Users,
  Home,
  Truck,
  BarChart,
  Sliders,
  Mail,
} from "react-feather";

const pagesSection = [
  {
    href: "/",
    icon: Sliders,
    title: "Etusivu",
    tourStep: 1,
    disabled: false,
    alt: "text",
    // No permission required - everyone can access dashboard
  },
  {
    href: "/associations",
    icon: AccountBalance,
    title: "Tiekunta",
    tourStep: 2,
    disabled: false,
    alt: "text",
    permission: { resource: "association", action: "read" },
  },
  {
    href: "/users",
    icon: Users,
    title: "Käyttäjät",
    tourStep: 3,
    disabled: false,
    alt: "text",
    permission: { resource: "user", action: "read" },
  },
  {
    href: "/roads",
    icon: Truck,
    title: "Tiet",
    tourStep: 4,
    disabled: false,
    alt: "text",
    permission: { resource: "road", action: "read" },
  },
  {
    href: "/properties",
    icon: Home,
    title: "Kiinteistöt",
    tourStep: 5,
    disabled: false,
    alt: "text",
    permission: { resource: "property", action: "read" },
  },
  {
    href: "/accounting",
    icon: BarChart,
    title: "Talous",
    disabled: false,
    alt: "text",
    permission: { resource: "account", action: "read" },
    children: [
      {
        href: "/accounting/coa",
        title: "Tilikartta",
        permission: { resource: "account", action: "read" },
      },
      // {
      //   href: "/accounting/budget",
      //   title: "Budjetointi",
      //   disabled: true,
      // },
      {
        href: "/accounting/fiscal-years",
        title: "Tilikaudet",
        permission: { resource: "account", action: "read" },
      },
      {
        href: "/accounting/ledger",
        title: "Pääkirja",
        permission: { resource: "account", action: "read" },
      },
      {
        href: "/accounting/journal",
        title: "Päiväkirja",
        permission: { resource: "account", action: "read" },
      },
      {
        href: "/accounting/financial-statement",
        title: "Tulos & Tase",
        permission: { resource: "account", action: "read" },
      },
      {
        href: "/accounting/vouchers",
        title: "Tositteet",
        permission: { resource: "voucher", action: "read" },
      },
      {
        href: "/accounting/invoices",
        title: "Laskutus",
        permission: { resource: "invoice", action: "read" },
      },
      {
        href: "/accounting/unitization",
        title: "Yksiköinti",
        permission: { resource: "unitization", action: "read" },
      },
      {
        href: "/accounting/units",
        title: "Maksuunpanoluettelo",
        permission: { resource: "unit", action: "read" },
      },
      {
        href: "/accounting/bank",
        title: "Pankkiyhteys",
        permission: { resource: "bank-connection", action: "read" },
      },
      {
        href: "/accounting/bank/transactions",
        title: "Pankkitapahtumat",
        permission: { resource: "bank-transaction", action: "read" },
      },
      {
        href: "/accounting/bank/unmatched",
        title: "Täsmäyttämättömät",
        permission: { resource: "bank-transaction", action: "read" },
      },
    ],
  },
  {
    href: "/messages",
    icon: Mail,
    title: "Keskustelut",
    disabled: false,
    alt: "text",
    // No permission required - everyone can access messages
  },
  // {
  //   href: "/quiz",
  //   icon: QuestionMark,
  //   title: "Kyselyt",
  //   disabled: true,
  //   alt: "text",
  // },
  {
    href: "/meetings",
    icon: Groups,
    title: "Kokoukset",
    disabled: false,
    alt: "text",
    permission: { resource: "meeting", action: "read" },
    // children: [
    //   {
    //     href: "/meetings",
    //     title: "Kokouskutsut",
    //   },
    // ],
  },
  {
    href: "/notices",
    icon: Campaign,
    title: "Tiedotteet",
    disabled: false,
    alt: "text",
  },
  {
    href: "/files",
    icon: Folder,
    title: "Tiedostot",
    disabled: false,
    alt: "text",
    permission: { resource: "file", action: "read" },
  },
  {
    href: "/map",
    icon: Map,
    title: "Kartta",
    disabled: false,
    alt: "text",
    // No permission required - everyone can view map
  },
  // {
  //   href: "/website",
  //   icon: Language,
  //   title: "Kotisivut",
  //   disabled: true,
  //   alt: "text",
  // },
  {
    href: "/docs",
    icon: Help,
    title: "Ohjeet",
    disabled: false,
    alt: "text",
    // No permission required - everyone can access help
  },
  {
    href: "/contact",
    icon: Chat,
    title: "Yhteys",
    disabled: false,
    alt: "text",
    // No permission required - everyone can contact support
  },
  {
    href: "/subscriptions",
    icon: Receipt,
    title: "Tilaukset",
    disabled: false,
    alt: "text",
    superadminOnly: true,
  },
  {
    href: "/gdpr-purge",
    icon: DeleteForever,
    title: "GDPR-poisto",
    disabled: false,
    alt: "text",
    superadminOnly: true,
  },
] as SidebarItemsType[];

const navItems = [
  {
    title: "Sivut",
    pages: pagesSection,
  },
];

export default navItems;
